import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericEntityList from '../../components/Common/GenericEntityList';

const TokenManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateToken = () => {
    navigate('/tokens/create');
  };

  return (
    <GenericEntityList
      entityType="token"
      detailsRoute="/tokens"
      onCreateClick={handleCreateToken}
      createButtonLabel="Add Token"
      showCreateButton={true}
      showExportButton={true}
    />
  );
};

export default TokenManagement;

